import {Directive, TemplateRef, input, inject} from "@angular/core"
import {MatTable} from "@angular/material/table"

@Directive({selector: "[matCellDef]"})
export class TypedMatCellDefDirective<T> {
    readonly matCellDefTable = input.required<MatTable<T>>()
    private readonly contentTemplate = inject(TemplateRef<T>)

    static ngTemplateContextGuard<T>(dir: TypedMatCellDefDirective<T>, ctx: unknown): ctx is {$implicit: T} {
        return true
    }
}
